export const setOrDeleteQueryParams = (queryParams, paramsToSetOrDelete) => {
    for (const [key, value] of Object.entries(paramsToSetOrDelete)) {
        value ? queryParams.set(key, value) : queryParams.delete(key);
    }
};
